import { render, staticRenderFns } from "./BaseIconButton.vue?vue&type=template&id=a65af8d8&scoped=true"
import script from "./BaseIconButton.vue?vue&type=script&lang=js"
export * from "./BaseIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65af8d8",
  null
  
)

export default component.exports